export default __webpack_public_path__ + "static/media/phinestsArabic.04896345.png";